<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card title="SPRAY DRY SUNDRY">
        <template slot="actions">
          <vs-button
            @click="addNewRow"
            icon-pack="feather"
            icon="icon-plus"
            color="primary"
            type="filled"
          >
            Add New
          </vs-button>
        </template>

        <vs-table stripe class="mt-8" :data="list">
          <template slot="thead">
            <vs-th>CODE</vs-th>
            <vs-th>NAME</vs-th>
            <vs-th>CURRENCY</vs-th>
            <vs-th>CREATED BY</vs-th>
            <vs-th>ACTIONS</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr v-for="(item, index) in list" :key="item.id">
              <vs-td>{{ item.code }}</vs-td>
              <vs-td>{{ item.name }}</vs-td>
              <vs-td>{{ item.currency.code }}</vs-td>
              <vs-td>{{ item.created_by.name }}</vs-td>
              <vs-td>
                <div style="display: flex; align-items: center">
                  <vx-tooltip text="Update" position="top">
                    <vs-button
                      @click.stop="editRow(item)"
                      size="small"
                      color="warning"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit-2"
                    >
                    </vs-button>
                  </vx-tooltip>

                  <vx-tooltip text="Add or update costs" position="top">
                    <vs-button
                      @click.stop="addCosts(item)"
                      class="ml-2"
                      size="small"
                      color="success"
                      type="border"
                      icon-pack="feather"
                      icon="icon-dollar-sign"
                    >
                    </vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <CreateSprayDrySundryPopUp
      ref="createSprayDrySundryPopUp"
      @refreshData="refreshData"
    />
    <DrySundryCostsPopUp ref="drySundryCostsPopUp" @refreshData="refreshData" />
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import CreateSprayDrySundryPopUp from "@/components/popups/settings/spray-dry-carreir/CreateSprayDrySundry.vue";
import DrySundryCostsPopUp from "@/components/popups/settings/spray-dry-carreir/DrySundryCostsPopUp.vue";
const SprayDryCostRepository = RepositoryFactory.get("spray_dry_cost");

export default {
  name: "SprayDrySundry",
  data() {
    return {
      list: [],
      meta: null,
    };
  },
  components: {
    CreateSprayDrySundryPopUp,
    DrySundryCostsPopUp,
  },
  async mounted() {
    await this.getSprayDryCarriersList();
  },
  methods: {
    refreshData() {
      this.getSprayDryCarriersList();
    },

    async getSprayDryCarriersList() {
      const payload = (await SprayDryCostRepository.getSprayDrySundryList())
        .data;

      this.list = payload.data.sort((a, b) => a.order - b.order);
      this.meta = payload.meta;
    },

    addCosts(item) {
      this.$refs.drySundryCostsPopUp.openPopup(item.id);
    },

    addNewRow() {
      this.$refs.createSprayDrySundryPopUp.openPopup();
    },

    editRow(item) {
      this.$refs.createSprayDrySundryPopUp.openPopup(item.id);
    },
  },
};
</script>
